<template>
<mu-card>
  <mu-card-header title="Myron" subTitle="sub title">
    <mu-avatar icon="account_circle" slot="avatar"/>
  </mu-card-header>
  <mu-card-title title="Content Title" subTitle="Content Title"/>
  <mu-card-text>
    正文
  </mu-card-text>
  <mu-card-actions>
    <mu-flat-button label="Action 1"/>
  </mu-card-actions>
</mu-card>
</template>
<script>
export default {
    name: 'card'
}
</script>



// WEBPACK FOOTER //
// card.vue?75751d30